/**
 * Рекурсивно ищет папку по её id в дереве папок.
 *
 * @param {Object} folder - Текущий узел дерева (папка), с которого начинается поиск.
 * @param {string} id - Искомый идентификатор папки.
 * @returns {Object|null} - Найденная папка или null, если папка не найдена.
 */
 export function findFolderById(folder, id) {
  // Если id текущей папки совпадает с искомым — возвращаем её
  if (folder.id === id) return folder;

  // Если у папки нет вложенных элементов, прекращаем поиск
  if (!folder.children) return null;

  // Перебираем всех потомков папки
  for (const child of folder.children) {
    // Рекурсивно ищем в дочернем элементе
    const found = findFolderById(child, id);
    
    // Если папка найдена в поддереве, возвращаем её
    if (found) return found;
  }

  // Если ничего не найдено, возвращаем null
  return null;
}
